export const IS_PROD_ENV = import.meta.env.VITE_VERCEL_ENV === 'production';
export const IS_STAGING_ENV =
  import.meta.env.VITE_VERCEL_GIT_COMMIT_REF === 'staging' ||
  import.meta.env.VITE_VERCEL_GIT_COMMIT_REF === 'claims-staging' ||
  import.meta.env.VITE_VERCEL_GIT_COMMIT_REF === 'jaidev/claims-create' ||
  import.meta.env.VITE_VERCEL_ENV === 'preview';
export const IS_DEVELOPMENT_ENV =
  import.meta.env.VITE_VERCEL_ENV === 'development' || import.meta.env.DEV;

const getXPlumTokenCookieNameByEnv = () => {
  return IS_DEVELOPMENT_ENV || IS_STAGING_ENV
    ? 'x-plum-staging-token'
    : 'x-plum-prod-token';
};

const getXPlumDoctorTokenName = () => {
  return IS_DEVELOPMENT_ENV || IS_STAGING_ENV
    ? "x-plum-staging-doctor-token"
    : "x-plum-prod-doctor-token";
};



export const PLUM_SUPPORT_HOST =
  IS_STAGING_ENV || IS_DEVELOPMENT_ENV
    ? 'https://support-wip.plumhq.com'
    : 'https://support.plumhq.com';

/**
 * Reads a positive whole number out of the environment, falling back when the
 * variable is unset or not a number. Vite inlines `import.meta.env` at build
 * time, so these are baked into the bundle — changing one takes a redeploy,
 * not a restart.
 */
const positiveIntFromEnv = (
  value: string | undefined,
  fallback: number,
): number => {
  const parsed = Number.parseInt(value ?? '', 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

// add all env varialbes here
const AppConfig = {
  APP_NAME: 'telehealth-triage',
  OMS_BASE_URL: import.meta.env.VITE_OMS_BASE_URL,
  CORE_BACKEND_BASE_URL: import.meta.env.VITE_CORE_BACKEND_BASE_URL,
  EMPLOYEE_EXPERIENCE_BASE_URL: import.meta.env
    .VITE_EMPLOYEE_EXPERIENCE_BASE_URL,
  EMPLOYEE_EXPERIENCE_V3_BASE_URL: import.meta.env
    .VITE_EMPLOYEE_EXPERIENCE_V3_BASE_URL,
  CLAIMS_BASE_URL: import.meta.env.VITE_CLAIMS_BASE_URL,
  TELEHEALTH_BASE_URL: import.meta.env.VITE_TELEHEALTH_BASE_URL,
  TOKEN_ADDED_VIA_EXTERNAL_APPLICATION_EVENT:
    'TOKEN_ADDED_VIA_EXTERNAL_APPLICATION',
  LOCATION_REQUEST_REJECTED_EVENT: 'LOCATION_REQUEST_REJECTED',
  SEGMENT_LOADED_EVENT: 'SEGMENT_LOADED_EVENT',
  ANALYTICS_LOADED_EVENT: 'ANALYTICS_LOADED_EVENT',
  LOCATION_UPDATED_EVENT: 'LOCATION_UPDATED',
  GA_LOADED_EVENT: 'GA_LOADED_EVENT',
  MOBILE_BACK_PRESS_EVENT: 'MOBILE_BACK_PRESS_EVENT',
  USER_FIRST_NAME_COOKIE_NAME: 'USER_FIRST_NAME',
  ENTRY_SURFACE_COOKIE_NAME: 'entrySurface',
  GENDER_COOKIE_NAME: 'gender',
  DATE_OF_BIRTH_COOKIE_NAME: 'dateOfBirth',
  JWT_TOKEN_COOKIE_NAME: getXPlumTokenCookieNameByEnv(),
  LOCAL_STORAGE_JWT_TOKEN_KEY: getXPlumTokenCookieNameByEnv(),
  IDENTITY_TOKEN_COOKIE_NAME: getXPlumDoctorTokenName(),
  PLUM_APP_HOST_URL: import.meta.env.VITE_PLUM_APP_HOST_URL,
  SSO_HOST_URL: import.meta.env.VITE_SSO_HOST_URL,
  SSO_BASE_URL: import.meta.env.VITE_SSO_BASE_URL,
  POLICY_GPT_BOT_ID: '2477f8c7-30e0-48b7-8abb-4e8691185095',
  TRANSACTIONAL_BOT_ID: '8622806b-e03b-488a-8772-903f0ea18860',
  NEW_RELIC_LOG_ENDPOINT: import.meta.env.VITE_NEW_RELIC_LOG_ENDPOINT,
  PLUM_SUPPORT_HOST,
  BASE_PATH: '',
  HOME_PAGE: '/',
  SEGMENT_JAVASCRIPT_CLIENT: import.meta.env
    .VITE_PUBLIC_SEGMENT_JAVASCRIPT_CLIENT,
  SUPPORT_CENTER_BASE_URL: import.meta.env.VITE_SUPPORT_CENTER_BASE_URL,
  CHAT_FRAMEWORK_BASE_URL: import.meta.env.VITE_CHAT_FRAMEWORK_BASE_URL,
  DEV_TOOLS_ENABLED: import.meta.env.VITE_DEV_TOOLS_ENABLED === 'true',
  DEV_FLAG_VALUE: import.meta.env.VITE_DEV_FLAG_VALUE,
  COST_OF_AILMENTS_URL: import.meta.env.VITE_COST_OF_AILMENTS_URL,
  GA_TRACKING_ID: import.meta.env.VITE_GA_TRACKING_ID,
  FORCE_ANALYTICS_TURN_ON: !!import.meta.env.VITE_FORCE_ANALYTICS_TURN_ON,
  CLEVERTAP_ACCOUNT_ID: import.meta.env.VITE_CLEVERTAP_ACCOUNT_ID,
  SMARTLOOK_KEY: import.meta.env.VITE_SMARTLOOK_KEY,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  INTERNAL_TOKEN: import.meta.env.VITE_INTERNAL_TOKEN,
  CULT_BENEFIT_ID: import.meta.env.VITE_CULT_BENEFIT_ID,
  CULT_SKU_ID: import.meta.env.VITE_CULT_SKU_ID,
  POLICY_GPT_BASE_URL: import.meta.env.VITE_POLICY_GPT_BASE_URL,
  INITIAL_QUERY_SERVICE_TOKEN: import.meta.env.VITE_INITIAL_QUERY_SERVICE_TOKEN,
  SOCKET_SERVICE_URL: import.meta.env.VITE_SOCKET_SERVICE_URL,
  /**
   * How long a member is asked to wait before retrying a chat whose booking
   * found every doctor busy. Tunable because the right number is really "how
   * long until a chat slot frees up", which is a property of the doctor pool
   * and its load, not of this app.
   */
  DOCTORS_BUSY_RETRY_SECONDS: positiveIntFromEnv(
    import.meta.env.VITE_DOCTORS_BUSY_RETRY_SECONDS,
    60,
  ),
};

export default AppConfig;
